import React from 'react';
import { I18n as I } from 'react-redux-i18n';

import PropTypes from 'prop-types';

import Portlet from '../layout/Portlet';
import { formatCurrencyRounded, isNil } from 'vdlib';

import LookupsHelper from 'lib/LookupsHelper';

class AuctionMerchantData extends React.Component {
  render() {
    if (isNil(this.props.data)) return false;

    return (
      <Portlet
        title={`${I.t('AGENT_C') + ': ' + this.props.data.DistinctiveTitle}`}
        className="col-md-12"
        titleColorClass="font-purple-plum"
      >
        <div className="row static-info">
          <div className="col-md-4 name"> {I.t('OFFER')}: </div>
          <div className="col-md-8 value">
            {' '}
            {formatCurrencyRounded(this.props.bidAmount)}{' '}
          </div>
          {this.props.initialAmount ? (
            <div className="col-md-8 col-md-offset-4 value">
              {' '}
              (
              {formatCurrencyRounded(this.props.initialAmount) +
                ' ' +
                I.t('INITIAL_PRICE_SHORT')}
              )
            </div>
          ) : null}
        </div>
        <div className="row static-info">
          <div className="col-md-4 name"> {I.t('NAME_SURNAME')}: </div>
          <div className="col-md-8 value">
            {' '}
            {`${this.props.data.FirstName || '-'} ${
              this.props.data.SurName || ''
            }`}{' '}
          </div>
        </div>
        <div className="row static-info">
          <div className="col-md-4 name"> {I.t('TAXNUMBER')}: </div>
          <div className="col-md-8 value"> {this.props.data.AFM || '-'} </div>
        </div>
        <div className="row static-info">
          <div className="col-md-4 name"> {I.t('TAXOFFICE')}: </div>
          <div className="col-md-8 value">
            {' '}
            {LookupsHelper.getDescription(
              this.props.taxOffices,
              this.props.data.TaxOfficeID
            )}{' '}
          </div>
        </div>
        <div className="row static-info">
          <div className="col-md-4 name"> {I.t('ADDRESS')}: </div>
          <div className="col-md-8 value">
            {' '}
            {`${this.props.data.Address || '-'} `}{' '}
          </div>
        </div>
        <div className="row static-info">
          <div className="col-md-4 name"> {I.t('PHONE_SHORT')}: </div>
          <div className="col-md-8 value">
            {' '}
            {`${this.props.data.Phone || '-'} `}{' '}
          </div>
        </div>
        <div className="row static-info">
          <div className="col-md-4 name"> {I.t('FAX')}: </div>
          <div className="col-md-8 value">
            {' '}
            {`${this.props.data.Fax || '-'} `}{' '}
          </div>
        </div>
        <div className="row static-info">
          <div className="col-md-4 name"> {I.t('MOBILE')}: </div>
          <div className="col-md-8 value">
            {' '}
            {`${this.props.data.Mobile || '-'} `}{' '}
          </div>
        </div>
      </Portlet>
    );
  }
}

AuctionMerchantData.propTypes = {
  data: PropTypes.object,
  taxOffices: PropTypes.array,
  bidAmount: PropTypes.number,
  initialAmount: PropTypes.number,
};

export default AuctionMerchantData;
